import "core-js/modules/es6.array.is-array";
import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";
import "core-js/modules/es6.array.from";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.date.to-string";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.set";

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import ResizeObserver from 'resize-observer-polyfill';
import useLayoutEffect from '@react-hook/passive-layout-effect';
import useLatest from '@react-hook/latest';
/**
 * A React hook that fires a callback whenever ResizeObserver detects a change to its size
 *
 * @param target A React ref created by `useRef()` or an HTML element
 * @param callback Invoked with a single `ResizeObserverEntry` any time
 *   the `target` resizes
 */

var useResizeObserver = function useResizeObserver(target, callback) {
  var resizeObserver = getResizeObserver();
  var storedCallback = useLatest(callback);
  useLayoutEffect(function () {
    var didUnsubscribe = false;

    var callback = function callback(entries, observer) {
      if (didUnsubscribe) return;
      var targetEl = target && 'current' in target ? target.current : target;

      for (var i = 0; i < entries.length; i++) {
        var entry = entries[i];

        if (entry.target === targetEl) {
          storedCallback.current(entry, observer);
        }
      }
    };

    resizeObserver.subscribe(callback);
    return function () {
      didUnsubscribe = true;
      resizeObserver.unsubscribe(callback);
    };
  }, [target, resizeObserver, storedCallback]);
  useLayoutEffect(function () {
    var targetEl = target && 'current' in target ? target.current : target;
    if (!targetEl) return;
    resizeObserver.observer.observe(targetEl);
    return function () {
      return resizeObserver.observer.unobserve(targetEl);
    };
  }, [target, resizeObserver.observer]);
  return resizeObserver.observer;
};

var createResizeObserver = function createResizeObserver() {
  var callbacks = new Set();
  return {
    observer: new ResizeObserver(function (entries, observer) {
      var _iterator = _createForOfIteratorHelper(callbacks),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var callback = _step.value;
          callback(entries, observer);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }),
    subscribe: function subscribe(callback) {
      return callbacks.add(callback);
    },
    unsubscribe: function unsubscribe(callback) {
      return callbacks["delete"](callback);
    }
  };
};

var _resizeObserver;

var getResizeObserver = function getResizeObserver() {
  return !_resizeObserver ? _resizeObserver = createResizeObserver() : _resizeObserver;
};

export default useResizeObserver;